import PropTypes from 'prop-types';
import React from 'react';

import { INPUT_WIDTH } from '@commons/utils/styledLibraryComponents';

import { Input } from '@lib/inpulse/Input';

/**
 * Single text input shared by the external-client information / company blocks. Required fields are
 * flagged with a leading '*' (rendered red by the Input lib). `isReadOnly` disables edition for the
 * consultation mode of the client detail page.
 */
const ClientTextInput = ({ label, value, onChange, isRequired, isReadOnly }) => (
  <Input
    label={isRequired ? `* ${label}` : label}
    placeholder={label}
    readOnly={isReadOnly}
    type="text"
    value={value == null ? '' : value}
    width={INPUT_WIDTH.FULL}
    onChange={(event) => onChange(event.target.value)}
  />
);

ClientTextInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  isReadOnly: PropTypes.bool,
};

ClientTextInput.defaultProps = {
  value: '',
  isRequired: false,
  isReadOnly: false,
};

export default ClientTextInput;
